import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";

function _templateObject41() {
  var data = _taggedTemplateLiteral(["\n        padding-right: 44px;\n      "]);

  _templateObject41 = function _templateObject41() {
    return data;
  };

  return data;
}

function _templateObject40() {
  var data = _taggedTemplateLiteral(["\n        padding-right: 40px;\n      "]);

  _templateObject40 = function _templateObject40() {
    return data;
  };

  return data;
}

function _templateObject39() {
  var data = _taggedTemplateLiteral(["\n        padding-right: 30px;\n      "]);

  _templateObject39 = function _templateObject39() {
    return data;
  };

  return data;
}

function _templateObject38() {
  var data = _taggedTemplateLiteral(["\n    padding-right: 38px;\n    ", "\n    ", "\n    ", "\n  "]);

  _templateObject38 = function _templateObject38() {
    return data;
  };

  return data;
}

function _templateObject37() {
  var data = _taggedTemplateLiteral(["\n        padding-left: 44px;\n      "]);

  _templateObject37 = function _templateObject37() {
    return data;
  };

  return data;
}

function _templateObject36() {
  var data = _taggedTemplateLiteral(["\n        padding-left: 40px;\n      "]);

  _templateObject36 = function _templateObject36() {
    return data;
  };

  return data;
}

function _templateObject35() {
  var data = _taggedTemplateLiteral(["\n        padding-left: 30px;\n      "]);

  _templateObject35 = function _templateObject35() {
    return data;
  };

  return data;
}

function _templateObject34() {
  var data = _taggedTemplateLiteral(["\n    padding-left: 38px;\n    ", "\n    ", "\n    ", "\n  "]);

  _templateObject34 = function _templateObject34() {
    return data;
  };

  return data;
}

function _templateObject33() {
  var data = _taggedTemplateLiteral(["\n      ", "};\n      line-height: initial;\n      padding: 0px 13px;\n    "]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = _taggedTemplateLiteral(["\n      ", "};\n      line-height: initial;\n      padding: 0px 9px;\n    "]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteral(["\n      ", "};\n      line-height: initial;\n      padding: 0px 7px;\n    "]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex: 1;\n  min-width: 0;\n  width: 0;\n  border: none;\n  background: none;\n  outline: none;\n  box-sizing: border-box;\n  color: ", ";\n  border-radius: 4px;\n\n  &[type=\"search\"] {\n    appearance: textfield;\n  }\n\n  &::placeholder {\n    color: ", ";\n    font-style: italic;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    background-color: ", " !important;\n    color: ", ";\n    &::placeholder {\n      color: ", ";\n    }\n  }\n\n  ", "\n\n  ", "\n\n  ", ";\n  line-height: initial;\n  padding: 0px 9px;\n  ", "\n  ", "\n  ", "\n\n  /* Prefix */\n  ", "\n\n  /* Suffix */\n  ", "\n"]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["\n      border: none;\n    "]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["\n      i {\n        color: ", ";\n      }\n    "]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n      i {\n        color: ", ";\n      }\n    "]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n      i {\n        color: ", " !important;\n      }\n    "]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n        margin: 0px 16px;\n      "]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n        margin: 0px 10px;\n        font-size: ", "rem;\n      "]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n      height: 60px;\n    "]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n      height: 50px;\n    "]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n      height: 30px;\n      ", "\xA0 {\n        margin: -2px;\n      }\n    "]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n      border-color: ", ";\n    "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n      border-color: ", ";\n    "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n            border-color: ", ";\n            ", " {\n              border-color: ", ";\n            }\n          "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n      &:focus-within {\n        box-shadow: 0 8px 16px 0\n          ", "; /* TODO use box shadow color */\n        ", "\n      }\n    "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  border-radius: 6px;\n  border: solid 1px ", ";\n  background-color: ", ";\n  overflow: hidden;\n  padding: 3px;\n  margin-bottom: 2px;\n  box-sizing: border-box;\n  \n  box-shadow: none;\n  transition: box-shadow 180ms ease-in-out, border-color 180ms ease-in-out;\n  ", "\n\n  ", "\n\n  ", "\n  \n  /* Sizes */\n  width: 100%;\n  height: 40px;\n  ", "\n  ", "\n  ", "\n\n  /* Icons */\n  i {\n    color: ", ";\n    margin: 0px 12px;\n    font-size: ", "rem;\n    ", "\n    ", "\n  }\n  ", "\n  ", "\n  ", "\n\n  ", "\n  \n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding-left: 4px;\n  span {\n    background-color: ", ";\n    color: ", ";\n  }\n  span {\n    ", "\n    ", "\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  padding: 1px 1px 1px 4px;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      margin-left: 3px;\n      border-left-width: 1px;\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      margin-right: 3px;\n      border-right-width: 1px;\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      border-color: ", ";\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      border-color: ", ";\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  margin: -3px;\n  padding: 0;\n  background: none;\n  border: none;\n  border-style: solid;\n  border-width: 0px;\n  border-color: ", ";\n  outline: none;\n  cursor: pointer;\n  transition: background-color 180ms ease-in-out, border-color 180ms ease-in-out;\n  &:hover, &:focus {\n    background-color: ", ";\n  }\n  &:disabled {\n    cursor: not-allowed;\n    background: none;\n    color: ", " !important;\n  }\n  ", "\n\n  ", "\n  ", " \n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        > i {\n          color: ", " !important;\n        }\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      right: 0;\n      left: initial;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      left: 0;\n      right: initial;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  display: flex;\n  top: 0;\n  bottom: 0;\n  align-items: center;\n  pointer-events: none;\n  ", "\n  ", "\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { PureComponent } from "react";
import styled, { css } from "styled-components";
import { text } from "../Utils/Constants";
import withInputWrapper from "./shared/withInputWrapper";
import Label from "../Texts/Label";
var buttonSizes = {
  xl: "l",
  l: "m",
  m: "s",
  s: "xs"
};
var labelSizes = {
  xl: "l",
  l: "m",
  m: "s",
  s: "xs"
};

var InputText = /*#__PURE__*/function (_PureComponent) {
  _inherits(InputText, _PureComponent);

  function InputText(props) {
    var _this;

    _classCallCheck(this, InputText);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputText).call(this, props));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(InputText, [{
    key: "handleChange",
    value: function handleChange(e) {
      e.stopPropagation();
      var onChange = this.props.onChange;
      onChange && onChange(e.target.value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          name = _this$props.name,
          type = _this$props.type,
          value = _this$props.value,
          placeholder = _this$props.placeholder,
          onBlur = _this$props.onBlur,
          onFocus = _this$props.onFocus,
          onChange = _this$props.onChange,
          size = _this$props.size,
          required = _this$props.required,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly,
          pattern = _this$props.pattern,
          step = _this$props.step,
          autoComplete = _this$props.autoComplete,
          error = _this$props.error,
          valid = _this$props.valid,
          prefix = _this$props.prefix,
          suffix = _this$props.suffix,
          endButton = _this$props.endButton,
          suffixLabel = _this$props.suffixLabel,
          onPrefixClick = _this$props.onPrefixClick,
          onSuffixClick = _this$props.onSuffixClick,
          noBorder = _this$props.noBorder,
          inputRef = _this$props.inputRef,
          props = _objectWithoutProperties(_this$props, ["id", "name", "type", "value", "placeholder", "onBlur", "onFocus", "onChange", "size", "required", "disabled", "readOnly", "pattern", "step", "autoComplete", "error", "valid", "prefix", "suffix", "endButton", "suffixLabel", "onPrefixClick", "onSuffixClick", "noBorder", "inputRef"]);

      return React.createElement(InputWrapper, _extends({}, props, {
        size: size,
        error: error,
        valid: valid,
        disabled: disabled,
        noBorder: noBorder
      }), prefix && onPrefixClick && React.createElement(ButtonAddon, _extends({
        type: "button",
        isPrefix: true,
        onClick: onPrefixClick
      }, {
        disabled: disabled,
        error: error,
        valid: valid
      }), prefix), React.createElement(StyledInput, _extends({
        id: id,
        name: name,
        type: type,
        placeholder: placeholder,
        onBlur: onBlur,
        onFocus: onFocus,
        size: size,
        error: error,
        valid: valid,
        required: required,
        disabled: disabled,
        readOnly: readOnly,
        pattern: pattern,
        step: step,
        autoComplete: autoComplete
      }, {
        value: value !== null && value !== undefined ? value.toString() : "",
        withPrefix: !!prefix && !onPrefixClick,
        withSuffix: !!suffix && !onSuffixClick,
        onChange: this.handleChange,
        ref: inputRef
      })), prefix && !onPrefixClick && React.createElement(Addon, {
        isPrefix: true
      }, prefix), suffix && !onSuffixClick && React.createElement(Addon, {
        isSuffix: true
      }, suffix), endButton && React.createElement(ButtonContainer, null, React.cloneElement(endButton, {
        size: buttonSizes[size || "m"]
      })), suffixLabel && React.createElement(LabelContainer, {
        error: error,
        valid: valid
      }, React.createElement(Label, {
        size: labelSizes[size || "m"]
      }, suffixLabel)), suffix && onSuffixClick && React.createElement(ButtonAddon, _extends({
        type: "button",
        isSuffix: true,
        onClick: onSuffixClick
      }, {
        disabled: disabled,
        error: error,
        valid: valid
      }), suffix));
    }
  }]);

  return InputText;
}(PureComponent);

InputText.displayName = "InputText";
export default withInputWrapper({
  insetLabel: true
})(InputText);
export var Addon = styled.div(_templateObject(), function (props) {
  return props.isPrefix && css(_templateObject2());
}, function (props) {
  return props.isSuffix && css(_templateObject3());
}, function (props) {
  return props.hasText && css(_templateObject4(), function (props) {
    return props.theme.color("text", "primary");
  });
});
export var ButtonAddon = styled.button(_templateObject5(), function (props) {
  return props.theme.color("border", "primary");
}, function (props) {
  return props.theme.color("background", "primary");
}, function (props) {
  return props.theme.color("text", "tertiary");
}, function (props) {
  return props.error && css(_templateObject6(), props.theme.color("action", "danger"));
}, function (props) {
  return props.valid && css(_templateObject7(), props.theme.color("action", "success"));
}, function (props) {
  return props.isPrefix && css(_templateObject8());
}, function (props) {
  return props.isSuffix && css(_templateObject9());
});
export var ButtonContainer = styled.div(_templateObject10());
export var LabelContainer = styled.div(_templateObject11(), function (props) {
  return props.theme.color("background", "primary:darken");
}, function (props) {
  return props.theme.color("text", "primary");
}, function (props) {
  return props.error && css(_templateObject12(), props.theme.color("action", "danger:10"));
}, function (props) {
  return props.valid && css(_templateObject13(), props.theme.color("action", "success:10"));
});
export var InputWrapper = styled.div(_templateObject14(), function (props) {
  return props.theme.color("border", "primary");
}, function (props) {
  return props.theme.color("background", "primary:lighten");
}, function (props) {
  return !props.noBorder && css(_templateObject15(), props.theme.color("background", "primary:darken"), function (props) {
    return !props.valid && !props.error && css(_templateObject16(), function (props) {
      return props.theme.color("action", "dark");
    }, ButtonAddon, function (props) {
      return props.theme.color("action", "dark");
    });
  });
}, function (props) {
  return props.error && css(_templateObject17(), function (props) {
    return props.theme.color("action", "danger");
  });
}, function (props) {
  return props.valid && css(_templateObject18(), function (props) {
    return props.theme.color("action", "success");
  });
}, function (props) {
  return props.size === "s" && css(_templateObject19(), ButtonContainer);
}, function (props) {
  return props.size === "l" && css(_templateObject20());
}, function (props) {
  return props.size === "xl" && css(_templateObject21());
}, function (props) {
  return props.theme.color("text", "primary");
}, 24 / 16, function (props) {
  return props.size === "s" && css(_templateObject22(), 20 / 16);
}, function (props) {
  return props.size === "xl" && css(_templateObject23());
}, function (props) {
  return props.disabled && css(_templateObject24(), function (props) {
    return props.theme.color("text", "tertiary");
  });
}, function (props) {
  return props.valid && css(_templateObject25(), props.theme.color("action", "success"));
}, function (props) {
  return props.error && css(_templateObject26(), props.theme.color("action", "danger"));
}, function (props) {
  return props.noBorder && css(_templateObject27());
});
export var StyledInput = styled.input(_templateObject28(), function (props) {
  return props.theme.color("text", "primary");
}, function (props) {
  return props.theme.color("text", "tertiary");
}, function (props) {
  return props.theme.color("action", "soft");
}, function (props) {
  return props.theme.color("text", "tertiary");
}, function (props) {
  return props.theme.color("text", "tertiary");
}, function (props) {
  return props.error && css(_templateObject29(), props.theme.color("action", "danger:10"));
}, function (props) {
  return props.valid && css(_templateObject30(), props.theme.color("action", "success:10"));
}, text("text", "m"), function (props) {
  return props.size === "s" && css(_templateObject31(), text("text", "s"));
}, function (props) {
  return props.size === "l" && css(_templateObject32(), text("text", "m"));
}, function (props) {
  return props.size === "xl" && css(_templateObject33(), text("text", "l"));
}, function (props) {
  return props.withPrefix && css(_templateObject34(), function (props) {
    return props.size === "s" && css(_templateObject35());
  }, function (props) {
    return props.size === "l" && css(_templateObject36());
  }, function (props) {
    return props.size === "xl" && css(_templateObject37());
  });
}, function (props) {
  return props.withSuffix && css(_templateObject38(), function (props) {
    return props.size === "s" && css(_templateObject39());
  }, function (props) {
    return props.size === "l" && css(_templateObject40());
  }, function (props) {
    return props.size === "xl" && css(_templateObject41());
  });
});